import { useAskStudioAccessMutation } from '@carboncopyco/data';
import { OpenInNew1OutlineIcon } from '@carboncopyco/icons';
import type { IRecording } from '@carboncopyco/types';
import { DropdownItem, notify } from '@carboncopyco/ui';

const StudioVersion = {
  STUDIO: 'studio',
  STUDIO_V2: 'studio-v2',
} as const;

const getStudioUrl = (
  recorderStudioUrl: string,
  version: (typeof StudioVersion)[keyof typeof StudioVersion]
): string => {
  return `${recorderStudioUrl}&studio_version=${version}`;
};

interface RecorderStudioDropdownActionProps {
  organizationId: string;
  cloneId: IRecording['id'];
  goToStudio: (studioLink: string) => void;
}

export const RecorderStudioDropdownAction = ({
  organizationId,
  cloneId,
  goToStudio,
}: RecorderStudioDropdownActionProps) => {
  const [askAccessToStudio] = useAskStudioAccessMutation();

  return (
    <>
      {/* Studio V1 */}
      <DropdownItem
        iconLeft={<OpenInNew1OutlineIcon size={18} />}
        label="Open in Studio"
        onClick={() =>
          askAccessToStudio({
            organizationId,
            recordingId: String(cloneId),
          })
            .unwrap()
            .then((response) =>
              goToStudio(
                getStudioUrl(response.recorderStudioUrl, StudioVersion.STUDIO)
              )
            )
            .catch(() => notify.error('Error redirecting to Studio'))
        }
      />
      {/* Studio V2 */}
      <DropdownItem
        iconLeft={<OpenInNew1OutlineIcon size={18} />}
        label="Open in Studio V2"
        onClick={() =>
          askAccessToStudio({
            organizationId,
            recordingId: String(cloneId),
          })
            .unwrap()
            .then((response) =>
              goToStudio(
                getStudioUrl(
                  response.recorderStudioUrl,
                  StudioVersion.STUDIO_V2
                )
              )
            )
            .catch(() => notify.error('Error redirecting to Studio V2'))
        }
      />
    </>
  );
};
